import type { ReactElement, ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/*
 * The styled replacement for a native `title` attribute: wraps one element
 * and shows the bevel tooltip on hover / focus. A null label renders the
 * child untouched so callers can keep the "no hint when decorative" branch.
 */
type Props = {
  label: ReactNode | null | undefined;
  /** Where the bubble opens; matches Radix `side`. */
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: ReactElement;
};

export function Hint({ label, side = 'top', children }: Props) {
  if (label === null || label === undefined || label === '') return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  );
}
